import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import styles from './ticketMgmtUpdate.module.scss';
import UserLayout from '../../../../components/user-layout/UserLayout';
import authService from '../../../../utils/services/authService';
import ticketService from '../../../../utils/services/ticketService';

const TicketMgmtUpdate = () => {
  const [ticket, setTicket] = useState();
  const [isClosed, setIsClosed] = useState();

  const { id } = useParams();
  const navigate = useNavigate();
  const userData = authService.getUserData();

  useEffect(() => {
    ticketService.getTicketById(userData, id).then((res) => {
      if (res.data.success) {
        setTicket(res.data.data);
      }
    });
  }, []);

  useEffect(() => {
    if (ticket) {
      setIsClosed(ticket.closed);
    }
  }, [ticket]);

  const closeTicketHandle = (e) => {
    e.preventDefault();
    const updateData = {
      closed: true,
    };
    ticketService.updateTicket(id, updateData, userData).then((res) => {
      if (res.data.success) {
        setTicket(res.data.data);
      }
    });
  };

  const goBackHandle = () => {
    navigate('/admin/tickets');
  };
  return (
    <UserLayout>
      <section className={styles.ticketWrapper}>
        {ticket && (
          <section className={styles.ticket}>
            <h1 className={styles.ticket_subject}>
              {' '}
              Subject: {ticket.subject}
            </h1>
            <p className={styles.ticket_category}>
              Category: {ticket.category}
            </p>
            <p className={styles.ticket_issue}>Description: {ticket.issue}</p>
            {!isClosed ? (
              <p className={styles.ticket_closed}>Ticket hasn't been closed</p>
            ) : (
              <p className={styles.ticket_closed}>Ticket is closed</p>
            )}
            {!isClosed && (
              <button
                disabled={isClosed ? true : false}
                className={styles.ticket_btn}
                onClick={(e) => {
                  closeTicketHandle(e);
                }}
              >
                Close ticket
              </button>
            )}

            <button
              className={styles.ticket_btn}
              onClick={(e) => {
                goBackHandle();
              }}
            >
              Back
            </button>
          </section>
        )}
      </section>
    </UserLayout>
  );
};

export default TicketMgmtUpdate;
